import { getUserMail } from "../../services/util/getUserMail";
import { axiosBuySell, axiosUSD } from "../axios";

let userObj:any = {'email_id' : getUserMail()}
export function getStartEndDateSF(months:any, asset:any, type:any){
    return axiosUSD.post(`/intraday/get_startDate_endDate`,{
        "month": months, 
        "asset":asset, 
        "type":type,
        "username": userObj?.email_id})
    .then((res:any)=>{
        return res?.data;
    }).catch((e:any)=>console.log("ERROR:", e))
}
export function getHistoricalTradesSF(startDate: any, endDate: any, assetType: string, version: any, filterDropdownVersion:any) {
    return axiosBuySell.post(`/stock_future/get_trades`, {
        "startDate": startDate,
        "endDate": endDate,
        "asset": assetType,
        "version": version,
        "username": userObj?.email_id,
        "filterDropdownVersion" : filterDropdownVersion
    })
        .then((res:any) => {
            return res.data;
        }).catch((err:any) => console.log("Error in Stockfuture in traday trades : ", err))
}
export function getHistoricalCallsSF(startDate: any, endDate: any, assetType: string, version: any, filterDropdownVersion:any) {
    return axiosBuySell.post(`/stock_future/get_calls`, {
        "startDate": startDate,
        "endDate": endDate,
        "asset": assetType, 
        "version": version,
        "username": userObj?.email_id,
        "filterDropdownVersion" : filterDropdownVersion
    })
        .then((res:any) => {
            return res.data;
        }).catch((err:any) => console.log(err))
}
export function getHistoricalSRSF(startDate:any, endDate:any,assetType:string,version:any, filterDropdownVersion:any)
{
     return axiosBuySell.post(`/stock_future/get_sr`,{
         "startDate":startDate,
         "endDate":endDate,
         "asset":assetType,
         "version":version,
         "username": userObj?.email_id,
         "filterDropdownVersion" : filterDropdownVersion
        })
        .then((res:any) => {
            return res.data;
        }).catch((err:any) => console.log(err))
}
export function getHistoricalPlSF(startDate:any, endDate:any,assetType:string, version:string, filterDropdownVersion:any)
{
     return axiosBuySell.post(`/stock_future/get_pl`,{
        "startDate":startDate,
        "endDate":endDate,
        "asset":assetType,
        "version":version,
        "username": userObj?.email_id ,
        "filterDropdownVersion" : filterDropdownVersion
    })
        .then((res:any) => {
            return res.data;
        }).catch((err:any) => console.log(err))
}
export function getHistoricalPlPercentageSF(startDate:any, endDate:any,assetType:string, version:string, filterDropdownVersion:any)
{
     return axiosBuySell.post(`/stock_future/get_pl_percent`,{
        "startDate":startDate,
        "endDate":endDate,
        "asset":assetType,
        "version":version,
        "username": userObj?.email_id ,
        "filterDropdownVersion" : filterDropdownVersion
    })
        .then((res:any) => {
            return res.data;
        }).catch((err:any) => console.log(err))
}
export function getHistoricaleParameterSF(id:any,asset:any,version:any,date:any)
{
    return axiosBuySell.post(`/stock_future/get_parameter`,{
        "asset":asset,
        "version":version,
        "date":date,
        "id":id,
        "username": userObj?.email_id})
        .then((res:any)=>{
            return res.data
        }).catch((err:any)=>console.log(err))
}

export function getHistoricalTargetSlSF(id:any,asset:any,date:any,version:any)
{
    return axiosBuySell.post(`/stock_future/get_target_stoploss`,
    {
        "id":id,
        "asset":asset,
        "date":date,
        "version":version
        // "username": userObj?.email_id
    })
            .then((res:any) => {
                return res.data;
        }).catch((err:any) => console.log(err))
}

export function getHistoricalMtmDrawdownSF(id:any,asset:any,date:any,version:any)
{
    return axiosBuySell.post(`/stock_future/get_m2m_drawdown`,{

        "id":id,
        "asset":asset,
        "date":date,
       "version": version
    //    "username": userObj?.email_id
    })
            .then((res:any) => {
                return res.data;
        }).catch((err:any) => console.log(err))
}
